import { useLocalizationContext } from '@im/react-localization';
import { CopyRightTO } from '@im/ui-lib/types';
import { handleKenticoOnClick } from '../../app/nav/utils';
import { useCMSApiQuery } from '../../hooks/useCMSApiQuery';

export function useCopyrightLinks() {
  const { locale } = useLocalizationContext();
  const query = useCMSApiQuery<GetCopyRightsResponseTO>(`/cms/v1/quick-links`, {
    type: 'FooterCopyright',
    typelang: locale, //param added to create dependency on locale
  });
  //Mapper for Copyright Data
  return query.data?.items?.map((x: CopyRightDataTO) => {
    return {
      onClick:
        x.isModel && x.onClick ? handleKenticoOnClick(x.onClick) : undefined,
      openUrlInNewTab: x.openUrlInNewTab,
      route:
        x.openUrlInNewTab === false && x.url.startsWith('/cep/app/')
          ? x.url?.replace('/cep/app/', '/')
          : undefined,
      title: x.title,
      trackingTag: x.trackingTag,
      url: x.url,
    } as CopyRightTO;
  });
}

type GetCopyRightsResponseTO = {
  items: CopyRightDataTO[];
};

type CopyRightDataTO = {
  isModel: boolean;
  onClick: string;
  openUrlInNewTab: boolean;
  title: string;
  trackingTag: string;
  url: string;
};
